var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex w-full items-center gap-4" },
    [
      _c("JadeInputField", {
        attrs: {
          label: "",
          size: "medium",
          value: _vm.id,
          placeholder: _vm.$t("placeholder"),
          leadingItem: { type: "icon", content: "action-search" },
        },
        on: {
          "update:value": function ($event) {
            _vm.id = $event
          },
        },
      }),
      _c(
        "JadeButton",
        {
          staticClass: "w-28",
          attrs: {
            variant: "primary-solid",
            size: "medium",
            disabled: _vm.loading,
          },
          on: { click: _vm.searchClick },
        },
        [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
      ),
      _c(
        "div",
        [
          _vm.canRequestTerminal
            ? _c(
                "jade-dropdown",
                {
                  attrs: { allowedPlacements: ["bottom-end"], open: _vm.open },
                  on: {
                    toggleOpen: function ($event) {
                      _vm.open = !_vm.open
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function () {
                          return [
                            _c(
                              "JadeActionButton",
                              { attrs: { dropdownIndicator: "" } },
                              [_vm._v(" " + _vm._s(_vm.$t("actions")) + " ")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1131096119
                  ),
                },
                [
                  _c("jade-list-item", {
                    attrs: {
                      label: _vm.$t("request-card-machine"),
                      as: "button",
                    },
                    on: {
                      onClick: function ($event) {
                        return _vm.$router.push({
                          name: _vm.terminalRequestRouteName,
                        })
                      },
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "page-down",
                            undefined,
                            $event.key,
                            undefined
                          )
                        )
                          return null
                        return _vm.$router.push({
                          name: _vm.terminalRequestRouteName,
                        })
                      },
                    },
                  }),
                  _vm.showRequestPapperRoll
                    ? _c("jade-list-item", {
                        attrs: {
                          label: _vm.$t("request-paper-roll"),
                          as: "button",
                        },
                        on: {
                          onClick: function ($event) {
                            return _vm.$router.push({
                              name: _vm.terminalRollRequestRouteName,
                            })
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "page-down",
                                undefined,
                                $event.key,
                                undefined
                              )
                            )
                              return null
                            return _vm.$router.push({
                              name: _vm.terminalRollRequestRouteName,
                            })
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }